import { render, staticRenderFns } from "./EmailPage.vue?vue&type=template&id=39b7061e"
import script from "./EmailPage.vue?vue&type=script&lang=js"
export * from "./EmailPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports